/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const PurchaseDeliveryMethod = {
  Email: "EMAIL",
  Mail: "MAIL",
  Pickup: "PICKUP",
  None: "NONE",
} as const;

export type PurchaseDeliveryMethod =
  (typeof PurchaseDeliveryMethod)[keyof typeof PurchaseDeliveryMethod];

export type PurchaseDeliveryMethodEnumType = typeof PurchaseDeliveryMethod;
export type PurchaseDeliveryMethodOptional = PurchaseDeliveryMethod;
export type PurchaseDeliveryMethodTrackedI = PurchaseDeliveryMethod;
export type PurchaseDeliveryMethodTracked = PurchaseDeliveryMethod;
export type PurchaseDeliveryMethodMetaI = EnumMetaType<
  PurchaseDeliveryMethodEnumType,
  PurchaseDeliveryMethod
>;
export const PurchaseDeliveryMethodMeta = typeMetaEnum<
  PurchaseDeliveryMethodEnumType,
  PurchaseDeliveryMethod
>("PurchaseDeliveryMethod", PurchaseDeliveryMethod);
export function transformDatesPurchaseDeliveryMethod(
  model: PurchaseDeliveryMethod,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
